import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/variables.css";
import "./styles/reset.css";

import "./index.css";
import AppRouter from "./AppRouter";
import { CartProvider } from "./cart/CartContext";

const rootElement = document.getElementById("root");

// El build de producción incluye cada ruta completamente renderizada para
// buscadores y usuarios sin JavaScript. React la sustituye al arrancar.
if (rootElement.hasAttribute("data-seo-prerendered")) {
  rootElement.replaceChildren();
  rootElement.removeAttribute("data-seo-prerendered");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <CartProvider>
      <AppRouter />
    </CartProvider>
  </React.StrictMode>
);
